<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="企业名称："
        prop="vendorName">
        <el-input
          v-model="info.vendorName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="企业简称："
        prop="vendorShortname">
        <el-input
          v-model="info.vendorShortname"
          show-word-limit
          :maxlength="6"></el-input>
      </el-form-item>
      <el-form-item
        label="企业标签："
        prop="labels">
        <custom-tag-select
          v-model="info.labels"
          k="company_brand_image" />
      </el-form-item>
      <el-form-item
        label="经营范围："
        prop="companyBusinessCategorys">
        <custom-tag-select
          v-model="info.companyBusinessCategorys"
          k="company_business_category" />
      </el-form-item>
      <el-form-item
        label="企业简介："
        prop="vendorDesc">
        <el-input
          v-model="info.vendorDesc"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          show-word-limit
          :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item
        label="企业首图："
        prop="coverImage">
        <upload-with-crop
          v-model="info.coverImage"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[5,3]"
          :autoCropWidth="120"
          :autoCropHeight="72"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="图文详情："
        prop="descImages">
        <desc-images
          v-model="info.descImages"
          edit></desc-images>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消 </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"> 确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import CustomTagSelect from './custom-tag-select.vue'
import Common from '@/service/common'
import { getCommomData } from './index'
export default {
  name: 'EditVendorExtraModal',
  components: { UploadWithCrop, DescImages, CustomTagSelect },
  data() {
    return {
      loading: false,
      visible: false,
      info: { vendorId: null, vendorName: '', vendorShortname: '', vendorDesc: '', coverImage: [], descImages: [], labels: [], companyBusinessCategorys: [] },
      rules: {
        vendorName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        coverImage: [{ required: true, message: '请上传企业Logo', trigger: 'change' }],
        descImages: [{ required: true, message: '请上传企业图文信息', trigger: 'change' }],
        vendorShortname: [{ required: true, message: '请输入企业简称', trigger: 'blur' }],
        vendorDesc: [{ required: true, message: '请输入企业简介', trigger: 'blur' }],
        labels: [{ required: true, message: '请选择企业标签', trigger: 'change' }],
        companyBusinessCategorys: [{ required: true, message: '请选择经营范围', trigger: 'change' }]
      }
    }
  },
  computed: {
    title({ info }) {
      return info.vendorId ? '修改合作企业信息' : '新增合作企业信息'
    }
  },
  methods: {
    handleClosed() {
      this.info = { ...this.info, ...this.$options.data().info }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { coverImage, descImages, vendorId } = this.info
          const commonData = !vendorId ? getCommomData() : {}
          const postData = { ...this.info, coverImage: this.$stringfyImage(coverImage), descImages: this.$stringfyImage(descImages), ...commonData }
          Common[vendorId ? 'updatevendor' : 'addvendor']({ ...postData })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.loading = false
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.info = { ...this.info, ...options }
      this.visible = true
    }
  }
}
</script>
